import React, { Component } from "react";
import { connect } from "react-redux";
import DashboardWidgetContainer from "../../../containers/DashboardWidget/DashboardWidgetContainer";
import { widgetKeys } from "../../../constants";
import AwardsList from "./AwardsList";
import { ArrowRightAlt } from "@mui/icons-material";
import { Button, Box } from "@mui/material";
import { fetchAchievements } from "../../../redux/actions/achievementsActions";
import { bindActionCreators } from "redux";
import { push } from "connected-react-router";
import { withTranslation } from "react-i18next";
import { performanceLeaderboard } from "../../../routes/LearningCenterRoutes";

class AwardsWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false
    };
  }

  componentDidMount() {
    this.props.fetchAchievements();
  }
  handleMenuItemClick = menuItem => {
    if (menuItem.value === "collapse") {
      this.setState({ collapsed: !this.state.collapsed });
    }
  };
  render() {
    const { achievements, loading, t, push, dashboard } = this.props;
    const { collapsed } = this.state;

    return (
      <DashboardWidgetContainer
        dashboard={dashboard}
        widgetKey={widgetKeys.awards}
        widgetDataLoading={loading}
        title={t("awardWidget.title")}
        menuProps={{
          options: [],
          onMenuItemClick: this.handleMenuItemClick
        }}
        collapsed={collapsed}
        footer={
          <Box display="flex" justifyContent="flex-end" mr={-2}>
            <Button
              color="primary"
              endIcon={<ArrowRightAlt />}
              onClick={() => push(performanceLeaderboard)}
            >
              {t("awardWidget.viewAllAwardsBtn")}
            </Button>
          </Box>
        }
        fadeEffect
      >
        <AwardsList achievements={achievements} />
      </DashboardWidgetContainer>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchAchievements,
      push
    },
    dispatch
  );
}

const mapStateToProps = state => ({
  achievements: state.achievementsState.items,
  loading: state.achievementsState.loading
});

const TranslatedAwardsWidget = withTranslation()(AwardsWidget);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslatedAwardsWidget);
